import React, { useEffect, useState } from 'react';
import { ActivityIndicator } from '../activity-indicator/activity-indicator';
import AstuteAccordion from '../../../support/components/astute-accordion/astute-accordion';
import ServiceHandler from '../../../services/service-handler';
import { FusionTradeInButton } from './fusion-tradeIn-button';

interface Props {
    astuteTopicDiv: any;
    accordions: Element[];
    isTeslaCharger?: boolean;
    isFocusTradeIn: boolean;
    topicResponse: any;
}

export const FusionTradeInButtonContainer = (props: Props) => {
    const [recallsTradeInData, getRecallsTradeInData] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const buttonCodeToReplaceForFusionTradeIn = `<a href="https://www.ford.com/support/recalls/" target="_blank"><strong><u>Vehicle Refund Estimator</u></strong></a>`;

    const fusionTradeInButtonReplace = (
        a: string,
        accordionsArray: Element[]
    ) => {
        const buttonSplit =
            a.includes(buttonCodeToReplaceForFusionTradeIn) &&
            a?.split(buttonCodeToReplaceForFusionTradeIn);

        return (
            <>
                {buttonSplit && buttonSplit.length > 1 ? (
                    <>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: buttonSplit[0],
                            }}
                        />
                        {
                            <FusionTradeInButton
                                recallsTradeInData={recallsTradeInData}
                            />
                        }

                        {
                            <AstuteAccordion
                                topic={buttonSplit[1]}
                                accordions={accordionsArray}
                                eventName={'accordion-click'}
                                category={
                                    props.topicResponse?.data?.categoryName ||
                                    ''
                                }
                                subcategory={
                                    props.topicResponse?.data
                                        ?.subCategoryName || ''
                                }
                            />
                        }
                    </>
                ) : (
                    <AstuteAccordion
                        topic={props.astuteTopicDiv.innerHTML}
                        accordions={props.accordions}
                        eventName={'accordion-click'}
                        category={props.topicResponse?.data?.categoryName || ''}
                        subcategory={
                            props.topicResponse?.data?.subCategoryName || ''
                        }
                    />
                )}
            </>
        );
    };

    const recallsTradeInService = () => {
        if (props.isFocusTradeIn) {
            const currentDomain = window.location.hostname;
            ServiceHandler.RecallsService.getRecallsTradeInUrl(currentDomain)
                .then(response => {
                    response.tradeInLink
                        ? getRecallsTradeInData(response.tradeInLink)
                        : getRecallsTradeInData('');
                    return response;
                })
                .catch(error => {
                    console.error(
                        'Catch block of trade in service call ',
                        error
                    );
                })
                .finally(() => {
                    setLoading(true);
                });
        }
    };

    useEffect(() => {
        recallsTradeInService();
    }, []);

    return (
        <>
            {!loading && <ActivityIndicator />}
            {loading && recallsTradeInData && recallsTradeInData.length > 0 ? (
                <>
                    {fusionTradeInButtonReplace(
                        props.astuteTopicDiv.innerHTML,
                        props.accordions
                    )}
                </>
            ) : (
                loading &&
                props.isFocusTradeIn &&
                recallsTradeInData.length === 0 && (
                    <AstuteAccordion
                        topic={props.astuteTopicDiv.innerHTML}
                        accordions={props.accordions}
                        eventName={'accordion-click'}
                        category={props.topicResponse?.data?.categoryName || ''}
                        subcategory={
                            props.topicResponse?.data?.subCategoryName || ''
                        }
                    />
                )
            )}
        </>
    );
};
